import React from 'react';

const FinalTaxableAmount = ({ totals }) => {
   return (
      <>
         <div className="bg-gradient-to-br from-emerald-900/30 to-blue-900/30 backdrop-blur-sm rounded-2xl border border-emerald-500/30 p-5">
            <div className="text-center space-y-4">
               <div>
                  <div className="text-xs text-slate-400 mb-1">Taxable Amount</div>
                  <div className="text-2xl font-bold text-white">₹{totals.subtotal.toFixed(2)}</div>
               </div>
               <div className="h-px bg-gradient-to-r from-transparent via-slate-700 to-transparent"></div>
               <div className="flex justify-between text-xs">
                  {/* CGST AMOUNT */}
                  <span className="text-slate-400">GST</span>
                  <span className="font-medium text-blue-400">₹{totals.gst.toFixed(2)}</span>
               </div>
               <div className="flex justify-between text-xs">
                  {/* SGST AMOUNT */}
                  <span className="text-slate-400">SGST</span>
                  <span className="font-medium text-blue-400">₹{totals.gst.toFixed(2)}</span>
               </div>
               <div className="flex justify-between text-xs">
                  {/* IGST AMOUNT */}
                  <span className="text-slate-400">IGST</span>
                  <span className="font-medium text-blue-400">₹{totals.gst.toFixed(2)}</span>
               </div>
               <div className="flex justify-between text-xs">
                  <span className="text-slate-400">Round Off</span>
                  <span className="font-medium text-white">₹0.00</span>
               </div>
               <div className="h-px bg-gradient-to-r from-transparent via-emerald-500/30 to-transparent"></div>
               <div>
                  <div className="text-xs text-emerald-400 font-medium mb-2">NET PAYABLE</div>
                  <div className="text-4xl font-bold bg-gradient-to-r from-emerald-400 to-blue-400 bg-clip-text text-transparent">
                     ₹{totals.total.toFixed(2)}
                  </div>
               </div>
            </div>
         </div>
      </>
   );
};

export default FinalTaxableAmount;
